export enum CHEER_FOR_TEAM_CONTENTS_TYPE {
  TEXT_ONLY, EMOTICON, IMAGE, BET_HISTORY,
}